module.exports = __webpack_public_path__ + "media/images/fundraise/fundraise-flow-01-8f8c93f25ea5b0bd3eb9f4eb89f3e40f.png";